export const bill = {
    chart: {
        type: 'line',
        width: '100%',
        height: 40,
        sparkline: {
            enabled: true
        }
    },
    stroke: {
        width: 2
    },
    plotOptions: {
        bar: {
            columnWidth: '50%'
        }
    },
    colors:['var(--theme-color1)'],
    series: [{
        data: [25, 66, 41, 89, 63, 25, 25, 66, 41, 89, 63, 25]
    }],
    labels: [1,2,3,4,5,6,7,8,9,10],
    xaxis: {
        crosshairs: {
            width: 1
        },
    },
    tooltip: {
        fixed: {
            enabled: false
        },
        x: {
            show: false
        },
        y: {
            title: {
                formatter: function (seriesName) {
                    return ''
                }
            }
        },
        marker: {
            show: false
        }
    }
}    

export const food = {
    chart: {
        type: 'line',
        width: '100%',
        height: 40,
        sparkline: {
            enabled: true
        }
    },
    stroke: {
        width: 2
    },
    plotOptions: {
        bar: {
            columnWidth: '50%'
        }
    },
    colors:['var(--theme-color2)'],
    series: [{
        data: [25, 66, 41, 89, 63, 25, 25, 66, 41, 89, 63, 25]
    }],
    labels: [1,2,3,4,5,6,7,8,9,10],
    xaxis: {
        crosshairs: {
            width: 1
        },
    },
    tooltip: {
        fixed: {
            enabled: false
        },
        x: {
            show: false
        },
        y: {
            title: {
                formatter: function (seriesName) {
                    return ''
                }
            }
        },
        marker: {
            show: false
        }
    }
} 

export const utility = {
    chart: {
        type: 'line',
        width: '100%',
        height: 40,
        sparkline: {
            enabled: true
        }
    },
    stroke: {
        width: 2
    },
    plotOptions: {
        bar: {
            columnWidth: '50%'
        }
    },
    colors:['var(--theme-color3)'],
    series: [{
        data: [25, 66, 41, 89, 63, 25, 25, 66, 41, 89, 63, 25]
    }],
    labels: [1,2,3,4,5,6,7,8,9,10],
    xaxis: {
        crosshairs: {
            width: 1
        },
    },
    tooltip: {
        fixed: {
            enabled: false
        },
        x: {
            show: false
        },
        y: {
            title: {
                formatter: function (seriesName) {
                    return ''
                }
            }
        },
        marker: {
            show: false
        }
    }
}    

export const shopping = {
    chart: {
        type: 'line',
        width: '100%',
        height: 40,
        sparkline: {
            enabled: true
        }
    },
    stroke: {
        width: 2
    },
    plotOptions: {
        bar: {
            columnWidth: '50%'
        }
    },
    colors:['var(--theme-color4)'],
    series: [{
        data: [25, 66, 41, 89, 63, 25, 25, 66, 41, 89, 63, 25]
    }],
    labels: [1,2,3,4,5,6,7,8,9,10],
    xaxis: {
        crosshairs: {
            width: 1
        },
    },
    tooltip: {
        fixed: {
            enabled: false
        },
        x: {
            show: false
        },
        y: {
            title: {
                formatter: function (seriesName) {
                    return ''
                }
            }
        },
        marker: {
            show: false
        }
    }
}    